import React from "react";
// import { HeaderImages } from "../../components";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation } from "swiper";

const Header = () => {
  const categories = ["Animals", "Youth", "Seniors", "Education", "Medical"];
  return (
    <div className=" lg:p-0 container mx-auto lg:h-full flex flex-col items-start lg:items-center lg:flex-row justify-between !py-5">
      <div className="lg:ml-6 flex flex-col gap-8 text-primary">
        <div className="pt-10 lg:pt-0 text-6xl font-bold md:text-7xl lg:mt-0">
          Fundraising
        </div>
        <div className="text-4xl md:text-6xl">
          For People & Causes <br />
          You Care About!
        </div>
        <div className="flex justify-between border border-primary rounded-full h-10 w-full lg:w-4/5">
          <input
            type="text"
            className="pl-6 w-full border-none outline-none bg-transparent placeholder:text-primary text-xs"
            placeholder="Search a Campaign"
          />
          <button
            className="px-6 text-light rounded-full bg-primary h-full"
            type="button"
          >
            Search
          </button>
        </div>
        <div className="flex flex-col lg:items-center gap-2 lg:flex-row">
          <span className="text-lg font-bold">Compaigns: </span>
          <div className="flex gap-2">
            {categories.map((category, i) => {
              return (
                <a
                  className="text-xs p-2 border border-primary rounded-full hover:bg-primary hover:text-light"
                  href="#1"
                  key={i}
                >
                  {category}
                </a>
              );
            })}
          </div>
        </div>
      </div>
      <Swiper
        className="mySwiper w-full lg:w-2/4 !mx-0"
        spaceBetween={200}
        centeredSlides={false}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Autoplay, EffectFade, Navigation]}
      >
        <SwiperSlide className="flex flex-col-reverse  lg:flex-row items-start lg:items-end">
          <div className="underline text-primary text-center text-4xl ">
            Youth
          </div>
          <img
            src={process.env.PUBLIC_URL + "assets/images/youth1.png"}
            alt="Youth"
            className=" headerImg"
          />
        </SwiperSlide>
        <SwiperSlide className="flex flex-col-reverse lg:flex-row items-start lg:items-end ">
          <div className=" underline text-primary text-center text-4xl ">
            Animal
          </div>
          <img
            src={process.env.PUBLIC_URL + "assets/images/dog1.png"}
            alt="Animal"
            className="headerImg"
          />
        </SwiperSlide>
        <SwiperSlide className="flex flex-col-reverse lg:flex-row items-start lg:items-end ">
          <div className=" underline text-primary text-center text-4xl ">
            Seniors
          </div>
          <img
            src={process.env.PUBLIC_URL + "assets/images/old1.png"}
            alt="Seniors"
            className="headerImg"
          />
        </SwiperSlide>
        <SwiperSlide className="flex flex-col-reverse lg:flex-row items-start lg:items-end ">
          <div className=" underline text-primary text-center text-4xl ">
            Small Business
          </div>
          <img
            src={process.env.PUBLIC_URL + "assets/images/man1.png"}
            alt="Small Business"
            className="headerImg"
          />
        </SwiperSlide>
        <SwiperSlide className="flex flex-col-reverse lg:flex-row items-start lg:items-end ">
          <div className=" underline text-primary text-center text-4xl ">
            Technology
          </div>
          <img
            src={process.env.PUBLIC_URL + "assets/images/tech1.png"}
            alt="Tech"
            className="headerImg"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Header;
